module.exports = __webpack_public_path__ + "static/media/battery_dashboard_zh.20a6eec3.png";